import { render, staticRenderFns } from "./AssociationDetailOverlay.vue?vue&type=template&id=1127138b&"
import script from "./AssociationDetailOverlay.vue?vue&type=script&lang=ts&"
export * from "./AssociationDetailOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./AssociationDetailOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports